import { PageProps } from "gatsby";
import { createContext } from "react";

export const PageMetadataContext = createContext({
  slug: undefined as string | undefined,
  location: undefined as PageProps["location"] | undefined,
  breadcrumbs: undefined as
    | {
        url: string;
        title: string;
      }[]
    | undefined,
  title: undefined as string | undefined,
});
